export default __webpack_public_path__ + "static/media/neuschwanstein.5fca57f2.jpg";